import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment-timezone'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    winners: [],
    winnersByAwardType: {},
    winnersHashById: {},
    winnersIndexById: {},
    winningWorkById: {},
    breadcrumbList: [],
    areas: {},
    talkShows: [],
    talkShowsDateList: [],
    talkShowsDateListByMonth: [],
    talkShowsByDate: [],
    talkShowsReportsDateList: [],
    talkShowsReportsDateListByMonth: [],
    talkShowsReportsByDate: [],
    specialExhibitions: [],
    specialExhibitionsIndexById: {},
    specialExhibitionById: [],
    tsvLoadCompleteFlag: false
  },
  mutations: {
    setWinners (state, value) {
      state.winners = value

      let index = 0
      for (const winner of state.winners) {
        // winnerIdをキーとしたハッシュを作成
        Vue.set(state.winnersHashById, winner.id, winner)

        // winnerIdをキーとした順番を返す
        Vue.set(state.winnersIndexById, winner.id, index)

        // 受賞タイプ別の一覧を作成
        if (!state.winnersByAwardType[winner.awardType]) {
          Vue.set(state.winnersByAwardType, winner.awardType, [])
        }
        state.winnersByAwardType[winner.awardType].push(winner)

        for (const winningWork of winner.winningWorks) {
          Vue.set(state.winningWorkById, winningWork.id, winningWork)
        }

        index++
      }
    },
    setTalkShows (state, value) {
      state.talkShows = value.talkShows
      for (const talkShow of state.talkShows) {
        const date = moment(talkShow.startTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('M月D日')
        const month = moment(talkShow.startTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('M')
        const day = moment(talkShow.startTime, 'YYYY-MM-DD HH:mm:ss').tz('Asia/Tokyo').format('D')
        // 月一覧を作成
        if (!state.talkShowsDateListByMonth[month]) {
          Vue.set(state.talkShowsDateListByMonth, month, [])
        }
        // 日付一覧を作成
        if (!state.talkShowsByDate[date]) {
          Vue.set(state.talkShowsByDate, date, [])
          state.talkShowsDateList.push(date)
          state.talkShowsDateListByMonth[month].push(day)
        }
        // 日付をキーにしたリストの作成
        state.talkShowsByDate[date].push(talkShow)
        // レポートデータの作成
        if (talkShow.reportLink) {
          // 月一覧を作成
          if (!state.talkShowsReportsDateListByMonth[month]) {
            Vue.set(state.talkShowsReportsDateListByMonth, month, [])
          }

          // レポートの日付一覧
          if (!state.talkShowsReportsByDate[date]) {
            Vue.set(state.talkShowsReportsByDate, date, [])
            state.talkShowsReportsDateList.push(date)
            state.talkShowsReportsDateListByMonth[month].push(day)
          }
          // 日付をキーにしたリストの作成
          state.talkShowsReportsByDate[date].push(talkShow)
        }
      }
    },
    setSpecialExhibitions (state, value) {
      state.specialExhibitions = value.specialExhibitions
      let index = 0
      for (const specialExhibition of state.specialExhibitions) {
        // winnerIdをキーとした順番を返す
        Vue.set(state.specialExhibitionsIndexById, specialExhibition.id, index)
        index++
      }
    },
    setSpecialExhibition (state, value) {
      Vue.set(state.specialExhibitionById, value.specialExhibition.id, value.specialExhibition)
    },
    setTsvCompleteFlag (state, value) {
      state.tsvLoadCompleteFlag = value
    },
    setAreas (state, value) {
      state.areas = value
    }
  },
  actions: {
    setWinners (context, value) {
      context.commit('setWinners', value)
    },
    setTalkShows (context, value) {
      context.commit('setTalkShows', value)
    },
    setSpecialExhibitions (context, value) {
      context.commit('setSpecialExhibitions', value)
    },
    setSpecialExhibition (context, value) {
      context.commit('setSpecialExhibition', value)
    },
    setTsvCompleteFlag (context, value) {
      context.commit('setTsvCompleteFlag', value)
    },
    setAreas (context, value) {
      context.commit('setAreas', value)
    }
  },
  getters: {
    winners: (state) => {
      return state.winners
    },
    winnersById: (state) => (value) => {
      return state.winnersHashById[value]
    },
    winnersIndexById: (state) => (value) => {
      return state.winnersIndexById[value]
    },
    winnersByAwardType: (state) => (value) => {
      return state.winnersByAwardType[value]
    },
    winningWorkById: (state) => (value) => {
      return state.winningWorkById[value]
    },
    breadcrumbList: (state) => {
      return state.breadcrumbList
    },
    talkShows: (state) => {
      return state.talkShows
    },
    talkShowsDateList: (state) => {
      return state.talkShowsDateList
    },
    talkShowsDateListByMonth: (state) => (value) => {
      return state.talkShowsDateListByMonth[value]
    },
    talkShowsByDate: (state) => (value) => {
      return state.talkShowsByDate[value]
    },
    talkShowsReportsDateList: (state) => {
      return state.talkShowsReportsDateList
    },
    talkShowsReportsDateListByMonth: (state) => (value) => {
      return state.talkShowsReportsDateListByMonth[value]
    },
    talkShowsReportsByDate: (state) => (value) => {
      return state.talkShowsReportsByDate[value]
    },
    specialExhibitions: (state) => {
      return state.specialExhibitions
    },
    specialExhibitionsIndexById: (state) => (value) => {
      return state.specialExhibitionsIndexById[value]
    },
    specialExhibitionById: (state) => (value) => {
      return state.specialExhibitionById[value]
    },
    tsvLoadCompleteFlag: (state) => {
      return state.tsvLoadCompleteFlag
    },
    areas: (state) => {
      return state.areas
    }
  },
  modules: {
  }
})
